


import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;


export const fetchSubjectProgress = async (user_id, exam_type = 'upsc_mains') => {
  try {
    const response = await axios.get(`${BASE_URL}syllabus/subjects/progress`, {
      params: { 
        user_id,
        exam_type,
      },
      headers: {
        accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};
export const fetchTopicProgress = async (subjectId, userId) => {
  try {
    const response = await axios.get(`${BASE_URL}syllabus/subjects/${subjectId}/topics/progress`, {
      params: {
        user_id: userId,
      },
      headers: {
        accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};


export const fetchSubtopicCompletion = async (topicId, userId) => {
  try {
    const response = await axios.get(`${BASE_URL}syllabus/subtopics/completion`, {
      params: {
        topic_ids: topicId,
        user_id: userId,
      },
      headers: {
        accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};

export const markSubtopicComplete = async ({ userId, subjectId, topicId, subtopicId }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}syllabus/subtopics/mark-complete?user_id=${userId}&subject_id=${subjectId}&topic_id=${topicId}&subtopic_id=${subtopicId}`,
      null, // no body needed
      {
        headers: {
          "accept": "application/json"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking subtopic complete:", error);
    throw error;
  }
};

export const fetchSyllabusAggregate = async (userId, examType = 'upsc_mains') => {
  try {
    const response = await axios.get(`${BASE_URL}syllabus/aggregate`, {
      params: {
        user_id: userId,
        exam_type: examType,
      },
      headers: {
        accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};
export const getPriorityLearning = async (subjectName, userId) => {
  try {
    const response = await axios.get(`${BASE_URL}syllabus/prioritylearning`, {
      params: {
        subject_name: subjectName,
        user_id: userId,
      },
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching priority learning:", error);
    throw error;
  }
};


export const getProgressCard = async (userId) => {
  try {
    const response = await axios.get(`${BASE_URL}syllabus/progress/card`, {
      params: {
        user_id: userId,
      },
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching progress card:", error);
    throw error;
  }
};